import React from 'react'
import { RouteStatus } from 'common/routing/RouteStatus'
import { TheWestPageNotFound } from './TheWestPageNotFound'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const TheWestPageNotFoundRegistration = createRegisterableComponent('west-404-page', () => (
    <RouteStatus statusCode={404}>
        <TheWestPageNotFound />
    </RouteStatus>
))
